import { SharedState } from '@trello/shared-state';

export const bulkActionSelectedCardsSharedState = new SharedState<
  Record<string, Record<string, boolean>>
>({});
